/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `BASIC_INFO` - BASIC_INFO
 * * `RATES` - RATES
 * * `PROFESSIONAL_TRAITS` - PROFESSIONAL_TRAITS
 */
export enum ProviderCompletedRegistrationStepsEnum {
    BASIC_INFO = 'BASIC_INFO',
    RATES = 'RATES',
    PROFESSIONAL_TRAITS = 'PROFESSIONAL_TRAITS',
}
